export default __webpack_public_path__ + "f060c18b57be46d3483aef3e08b178d4.svg";